module.exports = __webpack_public_path__ + "static/media/learn-history.3ef628f8.svg";